import React from "react";
import Logo from "./Logo";
import { NavLink } from 'react-router-dom';

class Header extends React.Component {
    render() {
        const { title } = this.props;

        return (
            <div className="siteHeader-wrapper">
                <header className="siteHeader">
                    <NavLink to="/">
                        <Logo />
                    </NavLink>
                <h1>{title}</h1>
                </header>
            </div>
        )
    }
}
export default Header;